<!-- <app-header-style-two></app-header-style-two>

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Home</a></li>
                <li>Error</li>
            </ul>
            <h2>Error 404</h2>
        </div>
    </div>
</div> -->

<app-header-style-one></app-header-style-one>

<div class="error-404-area">
    <div class="container">
        <div class="notfound">
            <div class="notfound-bg">
                <div></div>
                <div></div>
                <div></div>
            </div>
            <h1>Oops!</h1>
            <h3>Hata 404 : Sayfa Bulunamadı</h3>
            <p>Aradığınız sayfa güncellenmektedir.
            </p>
            <a routerLink="/" class="default-btn"><i class='bx bx-home-circle icon-arrow before'></i><span
                    class="label">Ana Sayfa</span><i class="bx bx-home-circle icon-arrow after"></i></a>
        </div>
    </div>
</div>